import { USERS_LIST_DEFAULT_PAGE_SIZE } from "@/features/tenantUsers/usersList";
import type { DataTableColumn } from "@/shared/components/common/DataTable";
import type { ContentCreatorListRow } from "../types/contentCreator.types";

export function getContentCreatorsListingConfig(t: (key: string) => string) {
  return {
    entityLabel: t("contentCreators:list.entityLabel"),
    basePath: "/content-creators",
    searchPlaceholder: t("contentCreators:list.searchPlaceholder"),
    sampleSheetPath: "/content-creators/bulk-upload",
    bulkUploadPath: "/content-creators/bulk-upload",
    addPath: "/content-creators/add-content-creators",
    addLabel: t("contentCreators:list.addContentCreator"),
    pageSize: USERS_LIST_DEFAULT_PAGE_SIZE,
  } as const;
}

export function getContentCreatorsTableColumns(
  t: (key: string) => string,
): DataTableColumn<ContentCreatorListRow>[] {
  return [
    { key: "name", header: t("contentCreators:table.name") },
    { key: "email", header: t("contentCreators:table.email") },
    {
      key: "role",
      header: t("contentCreators:table.role"),
      render: (row) => roleLabel(row.role, t),
    },
    { key: "accountStatus", header: t("contentCreators:table.accountStatus") },
  ];
}

function roleLabel(
  role: ContentCreatorListRow["role"],
  t: (key: string) => string,
): string {
  if (role === "approver") return t("contentCreators:roles.approver");
  if (role === "publisher") return t("contentCreators:roles.publisher");
  return t("contentCreators:roles.creator");
}
